import { fetcher } from "helpers/fetcher";

import {
  TGetProgressGenerateAIJobSuggestionReq,
  TGetProgressGenerateAIJobSuggestionRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getProgressGenerateAIJobSuggestion = async (
  payload?: TGetProgressGenerateAIJobSuggestionReq
) => {
  return await fetcher<
    TGetProgressGenerateAIJobSuggestionRes,
    TGetProgressGenerateAIJobSuggestionReq["data"]
  >(ENDPOINT.BU.GET_PROGRESS_GENERATE_AI_JOB_SUGGESTION, {
    params: {
      idBu: payload?.data.idBu,
    },
    data: payload?.data,
    headers: {
      [API_HEADER.VERSION]:
        ENDPOINT.BU.GET_PROGRESS_GENERATE_AI_JOB_SUGGESTION.version,
      [API_HEADER.BU_ID]: payload?.idBu,
    },
  });
};

export const queryGetProgressGenerateAIJobSuggestion = async (
  payload?: TGetProgressGenerateAIJobSuggestionReq
) => {
  return (await getProgressGenerateAIJobSuggestion(payload)).data;
};

queryGetProgressGenerateAIJobSuggestion._key = (
  payload?: TGetProgressGenerateAIJobSuggestionReq,
  key?: string
) => [ENDPOINT.BU.GET_PROGRESS_GENERATE_AI_JOB_SUGGESTION.url, payload, key];
